import apiSetting from '@/api/apiSetting'
import { Message, MessageBox } from 'element-ui'
import store from '@/store'
import getRequest from '@/api/index'

/**
 * 自动登陆成功
 */
function autoLoginSuccess() {
  const request = getRequest()
  window._tokenExpiredRequests.forEach(item => {
    item.annex.disableRefreshToken = true
    item.resolve(request.service(item.options, item.annex))
  })
  window._tokenExpiredRequests = []
  window._isRefreshTokenLoading = false
}

/**
 * 自动登陆失败
 */
function autoLoginError() {
  tokenError()
  window._tokenExpiredRequests.forEach(item => item.reject(new Error(apiSetting.tokenExpiredMessage.title)))
  window._tokenExpiredRequests = []
  window._isRefreshTokenLoading = false
}

/**
 * 更新token失败提示
 */
function tokenError() {
  if (!window._isTokenErrorPrompt) {
    window._isTokenErrorPrompt = true
    const localError = apiSetting.tokenExpiredMessage
    MessageBox.confirm(localError.content, localError.title, {
      confirmButtonText: localError.confirm,
      cancelButtonText: localError.cancel,
      type: 'warning'
    }).then(() => store.dispatch('account/logout'))
      .catch(() => null)
      .finally(() => window._isTokenErrorPrompt = false)
  }
}

export default {
  /**
   * 显示错误信息toast
   */
  toast(annex, message) {
    if (!annex.disableToast) {
      Message.error(message)
    }
  },

  /**
   * 返回内容code的key值
   */
  getCodeKey(result) {
    return apiSetting.codeKeys.find(item => result[item])
  },

  /**
   * 返回网络错误内容
   */
  getStatusErrorMessage(status) {
    const localError = apiSetting.statusErrorMessage.find(item => item.code === status)
    return localError ? localError.msg : apiSetting.defaultErrorMessage
  },

  /**
   * 返回接口的错误内容
   */
  getResultErrorMessage(codeValue, result) {
    const key = apiSetting.messageKeys.find(item => result[item])
    return key ? (result[key] || apiSetting.defaultErrorMessage) : apiSetting.defaultErrorMessage
  },

  /**
   * 是否返回成功
   */
  isSuccess(codeValue) {
    return apiSetting.successCodes.findIndex(item => item === codeValue) !== -1
  },

  /**
   * 是否登陆过期
   */
  tokenExpired(codeValue) {
    return apiSetting.tokenExpiredCodes.findIndex(item => item === codeValue) !== -1
  },

  /**
   * 显示token过期对话框
   */
  showTokenError() {
    tokenError()
  },

  /**
   * 自动登陆
   */
  updateToken(options, annex) {
    return new Promise((resolve, reject) => {
      window._tokenExpiredRequests = window._tokenExpiredRequests || []
      window._tokenExpiredRequests.push({
        options,
        annex,
        resolve,
        reject
      })
      if (!window._isRefreshTokenLoading) {
        window._isRefreshTokenLoading = true
        store.dispatch('account/updateToken').then(() => autoLoginSuccess()).catch(() => autoLoginError())
      }
    })
  }
}
